import React from 'react'
import Styled from 'styled-components';
import Prism from 'prismjs'
import utils from './../../scripts/utils'

import 'prismjs/components/prism-jsx.min';
import 'prismjs/themes/prism.css'

const camelToSnake = utils.camelToSnake

if (typeof window !== "undefined") {
  var window = {}
}

class Example extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { code, name, filename, description } = this.props.example

    let ExampleComponent = <div></div>

    try {
      ExampleComponent = require(`../../shards-react/components/${camelToSnake(name)}/docs/${filename}`).default
    } catch (e) {}

    let cleanCode = code.replace(/((?:\/\*(?:[^*]|(?:\*+[^*\/]))*\*+\/)|(?:\/\/.*))/, '') // Remove comments
    cleanCode = cleanCode.replace(/\n\s*\n/g, '\n\n') // Remove double new lines
    const hCode = Prism.highlight(cleanCode, Prism.languages.jsx, 'javascript')

    return (
        <div>
            {description && <Description dangerouslySetInnerHTML={{ __html: description.contents }} />}
            <ExampleComponentWrapper>
              <ExampleComponent />
            </ExampleComponentWrapper>
            <PreWrapper className='language-jsx'>
                <code style={{ padding: 0 }} dangerouslySetInnerHTML={{ __html: hCode }} />
            </PreWrapper>
        </div>
    )
  }
}

export default Example;

const Description = Styled.div`
    > h1, > h2, > h3, > h4, > h5, > h6 {
        font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;
        font-weight: 600;
    }

    > h1 {
        margin-bottom: 30px;
    }

    > h2 {
        font-size: 24px;
        letter-spacing: 0;
    }
`

const ExampleComponentWrapper = Styled.div`
    padding: 20px;
    border: 1px solid #e6e9ec;
    box-shadow: 0 3px 8px 0 rgba(0,0,0,.03);
    border-radius: 5px 5px 0 0;
    border-bottom: 0;
    background: #fff;

    div.example {
      > *:last-of-type {
        margin-bottom: 0;
        margin-right: 0;
      }

      > * {
        margin-right: 4px;
      }
    }

`

const PreWrapper = Styled.pre`
    padding: 20px 30px;
    background: #f9f9fb !important;
    box-shadow: inset 0 0 10px #e3e7ea, inset 0 0 2px #e3e7ea, 0 1px 0 0 #fff;
    margin: 0 0 40px !important;
    border-radius: 0 0 5px 5px;
    text-shadow: 0 1px 0 #fff !important;
    border: 1px solid #e6e9ec;
    font-family: Roboto Mono,monospace;
    font-size: 12px;
    line-height: 1.2em;
    padding: 20px !important;
`
